import deviceTypesService from '../../services/device/deviceTypesService';
import uaUtils from '../../utils/uaUtils';
import {config} from '../config';

const getIsUsbFWUAvailableByType = (deviceType) => {
    const deviceTypeList = config.data.fwu.usb;

    return deviceTypeList?.some((item) => item === deviceType);
};

const getIsBleFWUAvailableByType = (deviceType) => {
    const deviceTypeList = config.data.fwu.ble;

    return deviceTypeList?.some((item) => item === deviceType) && !isDeviceBleDisabledByType(deviceType);
};

const isDeviceBleDisabledByType = (type) => {
    const listOfBleDisabledDeviceTypes = config.data.fwu.bleDisabled || [];
    const {name: platformName} = uaUtils.getOS();
    const browserName = uaUtils.getBrowserName();
    const result = deviceTypesService.checkIfBleConnectionIsDisabled(
        listOfBleDisabledDeviceTypes,
        type,
        platformName,
        browserName
    );

    return result;
};

export default {
    getIsBackgroundFwuCheckEnabled: () => config.data.fwu.isBackgroundFwuCheckEnabled,
    getIsUsbFWUAvailable: (deviceType) => getIsUsbFWUAvailableByType(deviceType),
    getIsBleFWUAvailable: (deviceType) => getIsBleFWUAvailableByType(deviceType),
    getAreNewFwuPopupsEnabled: () => config.data.fwu.areNewPopupsEnabled,
    getFwuReconnectAnimationVideo: () => config.data.fwu.reconnectAnimationVideo,
};
